import script from "./DateOverrideSection.vue?vue&type=script&setup=true&lang=js"
export * from "./DateOverrideSection.vue?vue&type=script&setup=true&lang=js"

import "./DateOverrideSection.vue?vue&type=style&index=0&id=1da38a6a&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1da38a6a"]])

export default __exports__